var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.track)?_c('div',{attrs:{"id":"track-tab"}},[_c('TrackTable',{ref:"table",attrs:{"track":_vm.track}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }